/** @typedef {'7' | '15' | '30' | 'custom'} DashboardPreset */

/**
 * Início do dia local (00:00:00.000).
 * @param {Date} d
 */
export function startOfLocalDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/**
 * Fim do dia local (23:59:59.999).
 * @param {Date} d
 */
export function endOfLocalDay(d) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}

/**
 * Últimos N dias inclusive (hoje conta como 1).
 * @param {number} n
 * @returns {{ from: Date; to: Date }}
 */
export function rangeLastNDaysInclusive(n) {
  const to = endOfLocalDay(new Date());
  const from = startOfLocalDay(new Date());
  from.setDate(from.getDate() - (Math.max(1, n) - 1));
  return { from, to };
}

/**
 * @param {string} ymd - YYYY-MM-DD
 * @returns {Date | null}
 */
export function parseYmdLocal(ymd) {
  const s = typeof ymd === 'string' ? ymd.trim() : '';
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const [y, m, d] = s.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
  return dt;
}

/**
 * @param {DashboardPreset} preset
 * @param {string} customFromYmd
 * @param {string} customToYmd
 * @returns {{ from: Date; to: Date } | null}
 */
export function resolveDashboardRange(preset, customFromYmd, customToYmd) {
  if (preset === '7') return rangeLastNDaysInclusive(7);
  if (preset === '15') return rangeLastNDaysInclusive(15);
  if (preset === '30') return rangeLastNDaysInclusive(30);
  const a = parseYmdLocal(customFromYmd);
  const b = parseYmdLocal(customToYmd);
  if (!a || !b) return null;
  const from = startOfLocalDay(a <= b ? a : b);
  const to = endOfLocalDay(a <= b ? b : a);
  if (from.getTime() > to.getTime()) return null;
  return { from, to };
}

/**
 * @param {string | undefined} isoOrMysql
 * @param {Date} from
 * @param {Date} to
 */
export function isTimestampInRange(isoOrMysql, from, to) {
  if (!isoOrMysql) return false;
  const t = new Date(isoOrMysql.replace(' ', 'T'));
  if (Number.isNaN(t.getTime())) return false;
  return t.getTime() >= from.getTime() && t.getTime() <= to.getTime();
}

/**
 * Chave YYYY-MM-DD em fuso local.
 * @param {Date} d
 */
export function toLocalYmd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Lista de dias entre from e to (inclusive), ordem cronológica.
 * @param {Date} from
 * @param {Date} to
 */
export function eachLocalDayInRange(from, to) {
  const out = [];
  const cur = startOfLocalDay(new Date(from));
  const end = startOfLocalDay(new Date(to));
  let guard = 0;
  while (cur.getTime() <= end.getTime() && guard++ < 400) {
    out.push(new Date(cur));
    cur.setDate(cur.getDate() + 1);
  }
  return out;
}
